import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useUserContext } from "@hooks/useUserContext";

import { OrganizationUsersTab } from "./OrganizationUsersTab";

export const RenderOrganizationUsersTab = () => {
  const navigate = useNavigate();
  const { user: currentUser } = useUserContext();

  useEffect(() => {
    if (currentUser.isOrgUser) {
      navigate("/organization");
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.isOrgUser]);

  if (currentUser.isAdministrator) {
    return <OrganizationUsersTab />;
  }
};
